import Entry, {
    getStaticPaths as getStaticPagePaths,
    getStaticProps as getStaticPageProps,
} from '../../components/pages/Article';

export default Entry;

export const getStaticProps = getStaticPageProps;
export const getStaticPaths = getStaticPagePaths;
